// extracted by mini-css-extract-plugin
export var smallSpinner = "_q3-0";